import React, { PropsWithChildren } from 'react';

export function ClientSideOnly({ children }: PropsWithChildren) {
  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  return <>{children}</>;
}
